import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledBackButtonContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: theme.spacing(1.25),
  borderBottom: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(1, 0),
  backgroundColor: theme.palette.common.white,
  color: theme.palette.text.secondary,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(1, 3),
  },
}));

export const StyledContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(0, 3, 4),
  },
}));

export const StyledMaxContent = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: '82.94%',
  margin: '0 auto',
  height: 'auto',

  [theme.breakpoints.down('lg')]: {
    maxWidth: '90%',
  },

  [theme.breakpoints.down('md')]: {
    maxWidth: '100%',
  },
}));
